import { render, staticRenderFns } from "./TaxGroupsTable.vue?vue&type=template&id=0c085878"
import script from "./TaxGroupsTable.vue?vue&type=script&lang=js"
export * from "./TaxGroupsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports